import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

export default class ScrollImage extends React.Component{
  constructor(props){
    super(props)

    this.state ={
      image: ['image1','image2','image3'],
      index: 0
    };
      this.nextImage = this.nextImage.bind(this);
      this.previousImage = this.previousImage.bind(this);
      this.componentDidMount = this.componentDidMount.bind(this);
  }

  nextImage(){
    this.setState({
      index: this.state.index + 1
    });
  }

  previousImage(){
    this.setState({
      index: this.state.index - 1
    });
  }

  componentDidMount(){
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if(xhr.readyState == 4){
        if(xhr.status == 200){
          console.log("Success");
          let res = xhr.responseText;
          res = JSON.parse(res);

          this.setState({
            image: res.results[0].picture.large
          })

          console.log(res.results[0].picture.large);
        }
        if(xhr.status == 404){
          console.log("File not found");
        }
      }
    }
    xhr.open('get', 'https://randomuser.me/api/');
    xhr.send();

  }



  render(){
    return(
      <form>
        <input type='button' value='Previous' onClick={this.componentDidMount} />
        <input type='button' value='Next' onClick={this.componentDidMount} />
        <img src={this.state.image} alt="image" />      
      </form>
    )
  }
}





// WEBPACK FOOTER //
// ./src/App.js